export default __webpack_public_path__ + "static/media/kitchen3-afterA-768w.2be330d2.webp";